import React, { useState } from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  const [isPrevSecDisabled, setIsPrevSecDisabled] = useState(true);
  const [isNextSecDisabled, setIsNextSecDisabled] = useState(false);

  const handleSlideSecChange = (swiper) => {
    setIsPrevSecDisabled(swiper.isBeginning);
    setIsNextSecDisabled(swiper.isEnd);
  };

  return (
    <main className="">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <Helmet>
        <title>Cryptocurrency Exchange Script - Beleaf Technologies</title>

        <meta
          name="title"
          content=" Cryptocurrency Exchange Script  - Beleaf Technologies"
        />
        <link
          rel="canonical"
          href="https://beleaftechnologies.com/cryptocurrency-exchange-script"
        />
        <meta
          name="description"
          content="Beleaf Technologies is the leading Centralized Crypto Exchange Development Company that can help you build your centralized exchange platform with a powerful matching engine that matches orders with the highest accuracy, allowing users to buy and sell instantly."
        />
        <meta
          name="keywords"
          content="Centralized exchange, Centralized Crypto, Centralized crypto exchange, Centralized Crypto exchange, CEX trading platform, Crypto exchange development services, Centralized Crypto exchange development, Centralized Crypto exchange development services, Centralized Crypto exchange development company"
        />
        <meta
          property="og:title"
          content=" cryptocurrency Exchange Script  - Beleaf Technologies"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />
        <meta
          property="og:url"
          content="https://beleaftechnologies.com/cryptocurrency-exchange-script"
        />
        <meta
          property="og:description"
          content="Beleaf Technologies is the leading Centralized Crypto Exchange Development Company that can help you build your centralized exchange platform with a powerful matching engine that matches orders with the highest accuracy, allowing users to buy and sell instantly."
        />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@BeleafTech" />
        <meta
          name="twitter:title"
          content="cryptocurrency Exchange Script  - Beleaf Technologies"
        />
        <meta
          name="twitter:description"
          content="Beleaf Technologies is the leading Centralized Crypto Exchange Development Company that can help you build your centralized exchange platform with a powerful matching engine that matches orders with the highest accuracy, allowing users to buy and sell instantly."
        />

        <meta name="twitter:image:alt" content="Beleaf Technologies" />
      </Helmet>
      <main className="cryptowallet_main centralized text-white">
        <section className="cryptowallet_bannersec d-flex flex-row align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex flex-row align-items-center">
                <div className="cryptowallet_bannersec_content hero_section_title d-flex flex-column">
                  <h1 className="mb-0">Cryptocurrency Exchange Script</h1>
                  <p className="cryptowallet_p mb-0">
                    Our goal is to offer a reliable solution for individuals and
                    businesses looking to enter the world of cryptocurrency
                    trading, with features developed to meet the needs of both
                    newbie and experienced users.
                  </p>
                  <Button
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Contact Us"
                    className="cryptowallet_button"
                  >
                    Get Free Consultation
                  </Button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="cryptowallet_bannersec_img_ik d-flex justify-content-center">
                  <img
                    src={require("../../image/exchange_script/Hero_banner2.webp")}
                    className="mobile_banner"
                    alt="Cryptocurrency Exchange Script "
                  />
                  <img
                    src={require("../../image/exchange_script/Ellipse 1.webp")}
                    className="ellipse"
                    alt="Cryptocurrency Exchange Script"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="crypt-ex-script-my">
          <div className="container">
            <div className="crypt-ex-script-bg">
              <h2 className="cryptowallet_h2 mb-0 text-center crypt-txt-dark">
                Cryptocurrency Exchange Script Build Your Exchange Platform
                Effortlessly
              </h2>
              <p className="cryptowallet_p text-center mt-4 crypt-build-mw crypt-txt-dark">
                The cryptocurrency exchange script is a ready-made software
                solution designed to help you launch your cryptocurrency
                exchange platform quickly and efficiently. As the crypto market
                continues to expand, entrepreneurs are increasingly seeking
                innovative ways to enter this lucrative industry. This script
                simplifies the process, offering customizable features and
                functionalities to meet your unique business needs.
              </p>
            </div>
          </div>
        </section>
        <section className="cryptowallet_whatissec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="cryptowallet_bannersec_img_ik d-flex justify-content-center">
                  <img
                    src={require("../../image/exchange_script/script_banner.webp")}
                    className="mobile_banner"
                    alt="Cryptocurrency Exchange Script"
                  />
                  <img
                    src={require("../../image/exchange_script/Ellipse 1.webp")}
                    className="ellipse-2"
                    alt="Cryptocurrency Exchange Script"
                  />
                </div>
              </div>
              <div className="col-lg-6 d-flex flex-row align-items-center">
                <div className="cryptowallet_whatissec_content d-flex flex-column">
                  <h2 className="cryptowallet_h2 mb-0">
                    What is A Cryptocurrency Exchange Script?
                  </h2>
                  <p className="cryptowallet_p mb-0">
                    A cryptocurrency exchange script is a pre-built software
                    that allows you to set up your own cryptocurrency trading
                    platform. It comes with features for buying, spot,
                    margin,selling, and trading digital currencies such as ETH
                    and BTC. The demand for cryptocurrency exchanges continues
                    to grow, entrepreneurs and businesses are looking for
                    innovative solutions to establish their presence in this
                    lucrative market. One such solution gaining popularity is
                    the Cryptocurrency Exchange Script.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="cryptowallet_button"
                  >
                    Get A Quote Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cryptowallet_types">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center mb-5">
                <h2 className="understanding_h2">
                  Understanding Cryptocurrency Exchange Script
                </h2>
                <p className="cryptowallet_p">
                  Cryptocurrency Exchange Script Are Pre-Built Software
                  Solutions Designed To Replicate The Functionalities And
                  Features Of Successful Cryptocurrency Exchanges. These Script
                  Are Typically Developed By Experienced Blockchain Developers
                  And Can Be Customized To Match The Requirements Of Businesses
                  And Individuals. By Using A Cryptocurrency Exchange Script,
                  Entrepreneurs Can Save Time, Effort, And Resources That Would
                  Otherwise Be Required To Build An Exchange Platform From
                  Scratch.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="cryptowallet_whatissec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex flex-column justify-content-center">
                <div className="cryptowallet_whatissec_content d-flex flex-column">
                  <h2 className="cryptowallet_h2 benefits_h2">
                    Benefits Of <br />
                    Cryptocurrency Exchange <br />
                    Script
                  </h2>
                  <p className="cryptowallet_p">
                    Developing a cryptocurrency exchange platform from scratch
                    can be an expensive endeavor. However, with a crypto
                    exchange script, businesses can significantly reduce
                    development costs. script provide a ready-made framework
                    that can be quickly customized and deployed, saving both
                    time and money.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="cryptowallet_whatissec_img d-flex benefit_banner crypt-ex-script-img">
                  <img
                    src={require("../../image/exchange_script/benefits_banner.webp")}
                    className="mobile_banner"
                    alt="Cryptocurrency Exchange Script"
                  />
                </div>
              </div>
            </div>
            {/* <img
              src={require("../../image/exchange_script/Ellipse 1.webp")}
              className="ellipse-3"
              alt="Cryptocurrency Exchange Script"
            /> */}
            <div className="arrow-1"></div>
          </div>
        </section>

        <section className="cryptowallet_whatissec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="cryptowallet_startyousec_img d-flex justify-content-center crypt-ex-script-img">
                  <img
                    src={require("../../image/exchange_script/time_save_banner.webp")}
                    className="mobile_banner"
                    alt="Cryptocurrency Exchange Script"
                  />
                </div>
              </div>
              <div className="col-lg-6 d-flex flex-row align-items-center">
                <div className="cryptowallet_whatissec_content d-flex flex-column">
                  <h2 className="cryptowallet_h2 benefits_h2 mb-0">
                    Time Saving
                  </h2>
                  <p className="cryptowallet_p mb-0">
                    Building a robust and secure cryptocurrency exchange
                    platform requires extensive development and testing. By
                    utilizing a script, businesses can leverage the existing
                    codebase and functionality, accelerating the development
                    process. This allows entrepreneurs to enter the market
                    quickly and gain a competitive edge.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* <img
            src={require("../../image/exchange_script/Ellipse 1.webp")}
            className="ellipse-4"
            alt="Cryptocurrency Exchange Script"
          /> */}
          <div className="arrow-2"></div>
        </section>
        <section className="cryptowallet_whatissec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex flex-row align-items-center">
                <div className="cryptowallet_whatissec_content d-flex flex-column">
                  <h2 className="cryptowallet_h2 benefits_h2 mb-0">
                    Proven <br />
                    Functionality
                  </h2>
                  <p className="cryptowallet_p mb-0">
                    Cryptocurrency exchange script are built based on successful
                    and established cryptocurrency exchanges. This means that
                    the core features and functionalities of these platforms
                    have already been tried and tested. By utilizing a script,
                    businesses can benefit from the proven functionality of
                    established exchanges, enhancing user trust and confidence.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="cryptowallet_startyousec_img d-flex justify-content-end  benefit_banner crypt-ex-script-img">
                  <img
                    src={require("../../image/exchange_script/functionality_banner.webp")}
                    className="mobile_banner"
                    alt="Cryptocurrency Exchange Script"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <img
            src={require("../../image/exchange_script/Ellipse 1.webp")}
            className="ellipse-5"
            alt="Cryptocurrency Exchange Script"
          /> */}
        </section>

        <section className="cryptowallet_types key_features">
          <div className="container exchange_script">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="understanding_h2">
                  Key Features of Cryptocurrency Exchange Script
                </h2>
                <div className="key_features_cards">
                  <div className="col-lg-4">
                    <div className="key_feature_card1">
                      <h3>User-Friendly Interface</h3>
                      <p>
                        Cryptocurrency exchange script offer intuitive and
                        user-friendly interfaces that make it easy for traders
                        to navigate the platform, perform transactions, and
                        manage their digital assets. These script often
                        incorporate advanced trading features, such as limit
                        orders, stop-loss orders, and charting tools, enhancing
                        the overall trading experience.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="key_feature_card1">
                      <h3>Enhanced Security</h3>
                      <p>
                        Security is a primary concern in the cryptocurrency
                        industry. Cryptocurrency exchange script are built with
                        robust security measures to protect user funds and
                        sensitive information. These include features like
                        two-factor authentication, encryption, and cold storage
                        wallets, ensuring a secure trading environment for
                        users.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="key_feature_card1">
                      <h3>Customization Options</h3>
                      <p>
                        Cryptocurrency exchange script can be customized to suit
                        specific business requirements. From branding and design
                        elements to additional functionalities, businesses have
                        the flexibility to tailor the platform to their unique
                        vision and target audience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <img
            src={require("../../image/exchange_script/Ellipse 1.webp")}
            className="ellipse-6"
            alt="Cryptocurrency Exchange Script"
          /> */}
        </section>

        <section className="crypt-how-my">
          <div className="container">
            <h2 className="cryptowallet_h2 text-center crypt-how-title">
              How to Choose the Right Cryptocurrency Exchange Script
            </h2>
            <p className="cryptowallet_p text-center mt-3">
              Selecting the right cryptocurrency exchange script is crucial for
              the success of your platform. Here are some factors to consider:
            </p>

            <div className="et-security-swiper">
              <Swiper
                spaceBetween={14}
                slidesPerView={4}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                  // el: ".forex-paginate",
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".crypt-how-prev-arrow",
                  nextEl: ".crypt-how-next-arrow",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                }}
                onSlideChange={handleSlideSecChange}
                onReachBeginning={() => setIsPrevSecDisabled(true)}
                onReachEnd={() => setIsNextSecDisabled(true)}
                onFromEdge={() => {
                  setIsPrevSecDisabled(false);
                  setIsNextSecDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="crypt-how-card">
                    <h6>Reputation of the Provider</h6>
                    <p>
                      Choose a cryptocurrency exchange script provider with a
                      positive customer reviews and proven track record.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="crypt-how-card">
                    <h6>Security Features</h6>
                    <p>
                      Ensure the script includes robust security measures like
                      2FA, encryption, and cold wallet support.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="crypt-how-card">
                    <h6>Customization Options</h6>
                    <p>
                      Opt for a script that allows you to customize features,
                      design, and functionalities.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="crypt-how-card">
                    <h6>Scalability</h6>
                    <p>
                      Verify that the script can handle future growth in users
                      and trading volumes.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="crypt-how-card">
                    <h6>RealDemo Version</h6>
                    <p>
                      Test the script with a demo version to evaluate its
                      features and performance.
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="et-sec-btn-wrapper">
                <button
                  className={`crypt-how-prev-arrow ${
                    isPrevSecDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevSecDisabled ? "#ffffff5c" : "#fff",
                    cursor: isPrevSecDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button
                  className={`crypt-how-next-arrow ${
                    isNextSecDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextSecDisabled ? "#ffffff5c" : "#fff",
                    cursor: isNextSecDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="crypt-launch-wrap">
          <div className="container crypt-launch-wrapper">
            <h2 className="cryptowallet_h2 mb-0 text-center">
              Launch Your Crypto Exchange with Our Cutting-Edge Script
            </h2>
            <p className="cryptowallet_p text-center mt-4 crypt-build-mw ">
              We offer a state-of-the-art cryptocurrency exchange script
              designed for businesses of all sizes. Our script combines advanced
              technology with user-friendly features, ensuring a smooth and
              secure trading experience for your users.
            </p>
            <div className="text-center mt-4">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="cryptowallet_button"
              >
                Get A Quote Now
              </button>
            </div>
          </div>
        </section>
        <section className="crypt-ex-why-wrap">
          <div className="container">
            <h2 className="cryptowallet_h2 text-center crypt-how-title">
              Why Choose Our Cryptocurrency Exchange Script?
            </h2>
            <p className="cryptowallet_p text-center mt-4">
              We offer a cutting-edge cryptocurrency exchange script tailored to
              meet the needs of modern businesses. Here’s what sets us apart:
            </p>
            <div className="row g-3 mx-0 mt-4">
              <div className="col-lg-6">
                <div className="crypt-how-card mb-0">
                  <h6>Experienced Development Team</h6>
                  <p>
                    A team of blockchain and crypto experts with years of
                    experience.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="crypt-how-card mb-0">
                  <h6>Comprehensive Support</h6>
                  <p>24/7 technical assistance to ensure smooth operations.</p>
                </div>
              </div>
              <div className="col-lg-4">
                {" "}
                <div className="crypt-how-card mb-0">
                  <h6>Regular Updates</h6>
                  <p>
                    Stay ahead with feature enhancements and software updates.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                {" "}
                <div className="crypt-how-card mb-0">
                  <h6>Affordable Pricing</h6>
                  <p>Competitive pricing without compromising on quality.</p>
                </div>
              </div>
              <div className="col-lg-4">
                {" "}
                <div className="crypt-how-card mb-0">
                  <h6>White-Label Solutions</h6>
                  <p>Launch a platform with your unique branding.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="cryptowallet_whatissec ">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="cryptowallet_bannersec_img_ik d-flex justify-content-center">
                  <img
                    src={require("../../image/exchange_script/conclusion_banner.webp")}
                    className=""
                    alt="Cryptocurrency Exchange Script"
                  />
                </div>
              </div>
              <div className="col-lg-6 d-flex flex-row align-items-center">
                <div className="cryptowallet_whatissec_content d-flex flex-column">
                  <h2 className="cryptowallet_h2 mb-0">Conclusion</h2>
                  <p className="cryptowallet_p mb-0">
                    Cryptocurrency exchange script have emerged as a
                    game-changer in the cryptocurrency industry. With their
                    cost-effective and time-saving nature, businesses can
                    quickly establish their presence in the market. The proven
                    functionality and enhanced security features of script
                    provide a solid foundation for entrepreneurs to build
                    successful cryptocurrency exchanges. By leveraging the
                    benefits and key features of these script, businesses can
                    tap into the immense potential of the cryptocurrency market
                    and offer users a seamless trading experience. Embracing
                    Cryptocurrency exchange script is a strategic move towards
                    staying ahead in this fast-paced and dynamic industry.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="cryptowallet_button"
                  >
                    Book Your Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Section id="about why new_faq bg_white CEX_faq">
          <section className="section bg_white CEX_faq" id="">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 d-flex align-items-center">
                  <div className="whybelaf faq">
                    <h2 className="">
                      Frequently asked <br />
                      Question
                    </h2>
                    <p></p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="comtent">
                    <div id="main">
                      <div className="container">
                        <div className="accordion" id="faq">
                          <div className="card">
                            <div className="card-header" id="faqhead1">
                              <a
                                href="#"
                                className="btn btn-header-link"
                                data-toggle="collapse"
                                data-target="#faq1"
                                aria-expanded="true"
                                aria-controls="faq1"
                              >
                                How long does it take to launch a cryptocurrency
                                exchange using a script?
                              </a>
                            </div>
                            

                            <div
                              id="faq1"
                              className="collapse show"
                              aria-labelledby="faqhead1"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Launching a cryptocurrency exchange with a
                                script can be done in a few days to a few weeks,
                                depending on the level of customization and
                                testing required. This is much faster compared
                                to developing an exchange from scratch, which
                                can take several months.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead2">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq2"
                                aria-expanded="true"
                                aria-controls="faq2"
                              >
                                Why should I use a cryptocurrency exchange
                                script?
                              </a>
                            </div>

                            <div
                              id="faq2"
                              className="collapse"
                              aria-labelledby="faqhead2"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Using a cryptocurrency exchange script saves
                                time and money compared to building an exchange
                                from scratch. It provides a secure, reliable
                                platform with built-in features, making it
                                easier to start your own exchange quickly.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead3">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq3"
                                aria-expanded="true"
                                aria-controls="faq3"
                              >
                                How secure is a cryptocurrency exchange script?
                              </a>
                            </div>

                            <div
                              id="faq3"
                              className="collapse"
                              aria-labelledby="faqhead3"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                A good cryptocurrency exchange script comes with
                                robust security features, such as encryption,
                                two-factor authentication, and anti-DDoS
                                protection. These features help protect your
                                platform.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead4">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq4"
                                aria-expanded="true"
                                aria-controls="faq4"
                              >
                                Can I customize a cryptocurrency exchange
                                script?
                              </a>
                            </div>

                            <div
                              id="faq4"
                              className="collapse"
                              aria-labelledby="faqhead4"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Yes, Our cryptocurrency exchange scripts are
                                customizable. You can add or remove features,
                                change the design, and develop the platform to
                                meet your specific needs and preferences.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead5">
                              <a
                                href="#"
                                className="btn btn-header-link collapsed"
                                data-toggle="collapse"
                                data-target="#faq5"
                                aria-expanded="true"
                                aria-controls="faq5"
                              >
                                What support is available for cryptocurrency
                                exchange scripts?
                              </a>
                            </div>

                            <div
                              id="faq5"
                              className="collapse"
                              aria-labelledby="faqhead5"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Reputable providers offer technical support,
                                regular updates, and maintenance services for
                                their cryptocurrency exchange scripts. This
                                makes sure your exchange runs smoothly and stays
                                updated with the latest security standards.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Section>
      </main>
      {/* <Footer /> */}
      <ServiceFooter />
    </main>
  );
}

export default Cex;
